module.exports = __webpack_public_path__ + "img/ecommerce-product-background-before.4c244b13.jpg";